/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { TableHead, TableRow, TableBody } from '@mui/material';

import { format } from 'date-fns';
import {
  GeneralTable,
  CustomTableCell,
  CustomTableRow,
  AvatarTableCell,
} from '../../index';
import { useState } from 'react';

export const ClockOutTable = (props) => {
  const allEmpData = props.allEmpData;
  const timesheetData = props.checkedOutTimesheet;
  const entryPerPage = 10;
  const [slice, setSlice] = useState([0, entryPerPage]);
  const data = timesheetData.map((time) => ({
    ...time,
    ...allEmpData.find((emp) => time.empid === emp._id),
  }));
  const workSetup = { 1: 'On-site', 2: 'WFH', 3: 'Deployed' };

  // PAGE CHANGE HANDLER
  const handlePageChange = (e, page) => {
    let currPage = page - 1;

    page === 1
      ? setSlice([0, entryPerPage])
      : setSlice([currPage * entryPerPage, page * entryPerPage]);
  };

  return (
    <GeneralTable
      sx={{
        borderRadius: '5px',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
        mb: 3.6,
        display: 'block',
      }}
      length={timesheetData.length}
      entryPerPage={entryPerPage}
      pageCount={props.pageCount}
      handlePageChange={handlePageChange}
    >
      <TableHead>
        <TableRow>
          <CustomTableCell value="Employee" />
          <CustomTableCell align="left" value="Date" />
          <CustomTableCell align="left" value="Check In" />
          <CustomTableCell align="left" value="Check Out" />
          <CustomTableCell align="left" value="Total Worked Hours" />
          <CustomTableCell align="left" value="Work Setup" />
          <CustomTableCell align="left" value="Work Description" />
        </TableRow>
      </TableHead>
      <TableBody>
        {data.slice(slice[0], slice[1]).map((emp, index) => (
          <CustomTableRow key={index}>
            <AvatarTableCell
              scope="row"
              value={`${emp.firstname} ${emp.lastname}`}
            />
            <CustomTableCell
              scope="row"
              value={format(new Date(emp.checkin), 'dd MMM yyyy')}
            />
            <CustomTableCell
              scope="row"
              value={format(new Date(emp.checkin), 'hh:mm:ss a')}
            />

            <CustomTableCell
              scope="row"
              value={format(new Date(emp.checkout), 'hh:mm:ss a')}
            />
            <CustomTableCell
              scope="row"
              value={Math.floor((emp.roundedtime / 60) * 1000) / 1000}
            />
            <CustomTableCell scope="row" value={workSetup[emp.worksetup]} />
            <CustomTableCell scope="row" value={emp.workdesc} />
          </CustomTableRow>
        ))}
      </TableBody>
    </GeneralTable>
  );
};
